<template>
    <div>
        <MdTitle v-bind:Text="$t('Incident.IncReportTitle')" />
        <div class="row">
            <div class="col-sm-12 col-md-12 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="SearchIncidents"
                        />
                        <div class="input-group-append">
                            <div class="input-group-append">
                                <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="SearchIncidents"
                                >
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="dateFrom"
                    @input="dateFrom = $event"
                    :Id="'ICRMultipleReportDateFrom'"
                    :Type="'date'"
                    :OnPressEnter="SearchIncidents"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="dateTo"
                    @input="dateTo = $event"
                    :Id="'ICRMultipleReportDateTo'"
                    :Type="'date'"
                    :OnPressEnter="SearchIncidents"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Category')"
                    v-bind:Options="IncidentOptions"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="CategoryModel"
                    v-bind:Multiple="true"
                    :Input="ChangeIncident"
                    v-bind:AllowEmpty="true"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12" v-if="SeeIncidentAdmin">
                <MdSelect
                    v-bind:Label="$t('Incident.IncReporter')"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Options="ReporterOptions"
                    v-bind:Model="ReporterModel"
                    v-bind:Multiple="true"
                    v-bind:AllowEmpty="true"
                    :Input="ChangeReporter"
                    v-bind:Name="'incident_report_select'"
                    id="incident_report_select"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Severity')"
                    v-bind:Options="SeverityOptions"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:AllowEmpty="true"
                    v-bind:Multiple="true"
                    v-bind:Model="SeverityModel"
                    :Input="ChangeSeverity"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Status')"
                    v-bind:Options="StatusOptions"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:AllowEmpty="true"
                    v-bind:Multiple="true"
                    v-bind:Model="StatusModel"
                    :Input="ChangeStatus"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Patient', 2)"
                    v-bind:Options="PatientsOptions"
                    v-bind:Model="PatientModel"
                    v-bind:FieldDescription="'patientname'"
                    v-bind:FieldCode="'patientcode'"
                    v-bind:Multiple="true"
                    v-bind:AllowEmpty="true"
                    :Input="ChangePatients"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Room', 2)"
                    v-bind:Options="RoomsOptions"
                    v-bind:Model="RoomModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="true"
                    v-bind:AllowEmpty="true"
                    :Input="ChangeRoom"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="text-md-right mt-3">
                    <button
                        v-on:click="SearchIncidents"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>
        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />

                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            v-bind:refTable="refTable"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                            v-bind:FieldsDate="FieldsDateArr"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="reportList"
                v-bind:Name="'btn_ReportList'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="onClickShowReport"
                v-bind:Name="'btn_Print'"
            />

            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$t('Shared.Export')"
                variant="primary"
                class="m-2"
            >
                <b-dropdown-item v-on:click="handlePdf('export')">{{
                    $t('Shared.PDF')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handlePdf('email')">{{
                    $t('Shared.PDFByEmail')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('export')">{{
                    $t('Shared.CSV')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('email')">{{
                    $t('Shared.CSVByEmail')
                }}</b-dropdown-item>
            </b-dropdown>
        </div>
        <DxPopup
            :visible="isReportVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="reportTitle"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
        >
            <ReportViewer
                ref="ICRMultipleRep"
                :ReportName="'ICRMultipleReport'"
                :ReportTitle="reportTitle"
                :IsAnAPIReport="true"
            />
        </DxPopup>

        <CSVExportHelper
            ref="csvExportHelper"
            v-bind:conformSubject="reportTitle"
            v-bind:sendEmailAPI="'/Utils/sendEmail'"
            v-bind:exportCsvAPI="'/IncidentReport/exportCSV'"
        >
        </CSVExportHelper>
    </div>
</template>

<script>
import Vue from 'vue';
import { DxPopup } from 'devextreme-vue/popup';
import EmployeeService from '@/services/employee.service';
import IncidentReport from '@/services/incidentreport.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import IncidentSetup from '@/services/incidentsetup.service';
import EnumService from '@/services/enum.service';
import RoomService from '@/services/rooms.service';
import PatientService from '@/services/patient.service';
import Utils from '../../../common/utils';
import IncidentReportSeveritySetupService from '@/services/incidentreportseveritysetup.service';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';

export default Vue.extend({
    name: 'ICRMultipleRep',
    mixins: [ShowMessage, Utils, DBFunctions],
    components: { DxPopup },
    data() {
        return {
            isReportVisible: false,
            SeeIncidentAdmin: false,
            reportParams: [],
            dateFrom: Utils.formatterDate(Date(), 'LLLL'),
            dateTo: Utils.formatterDate(Date(), 'LLLL'),
            showFilters: true,
            IncidentOptions: [],
            ReporterOptions: [],
            SeverityOptions: [],
            RoomsOptions: [],
            PatientsOptions: [],
            StatusOptions: EnumService.IncidentStatusOptions,
            CategoryModel: '',
            ReporterModel: '',
            SeverityModel: '',
            RoomModel: '',
            StatusModel: '',
            PatientModel: '',
            parameter: {
                SearchCriteria: '',
                PageNumber: null,
                PageSize: null,
                Status: true
            },
            paramCategory: '',
            paramReporter: '',
            paramSeverity: '',
            paramRoom: '',
            paramStatus: '',
            reportTitle: this.$t('Incident.IncReportTitle'),
            paramPatients: '',
            fullParam: {
                PageSize: 0,
                PageNumber: 0
            },
            items: [],
            fields: [
                //{ key: 'status', sortable: true, label: this.$t('Shared.Status'), class: 'text-rigth' },
                {
                    key: 'version',
                    sortable: true,
                    label: this.$t('Shared.IncVers'),
                    class: 'hidden'
                },
                {
                    key: 'incidentDate',
                    sortable: true,
                    label: this.$t('Incident.IncDate'),
                    class: 'text-rigth'
                },
                {
                    key: 'incidentTime',
                    sortable: true,
                    label: this.$t('Shared.Time'),
                    class: 'hidden'
                },
                {
                    key: 'severityName',
                    sortable: true,
                    label: this.$t('Shared.Severity'),
                    class: 'text-rigth'
                },
                {
                    key: 'primaryCategoryName',
                    sortable: true,
                    label: this.$t('Shared.Category'),
                    class: 'text-rigth'
                },
                {
                    key: 'principalParticipant',
                    sortable: true,
                    label: this.$tc('Incident.IncParticipant'),
                    class: 'text-rigth'
                },
                {
                    key: 'reporterName',
                    sortable: true,
                    label: this.$t('Incident.IncReporter'),
                    class: 'text-rigth'
                },
                {
                    key: 'reportedDate',
                    sortable: true,
                    label: this.$t('Incident.IncReportedDate'),
                    class: 'text-rigth'
                },
                {
                    key: 'roomName',
                    sortable: true,
                    label: this.$tc('Shared.Room'),
                    class: 'text-rigth'
                },
                {
                    key: 'locationName',
                    sortable: true,
                    label: this.$t('Shared.Location'),
                    class: 'text-rigth'
                },
                {
                    key: 'additionalLocation',
                    sortable: true,
                    label: this.$t('Incident.IncAditLocation'),
                    class: 'text-rigth'
                },
                {
                    key: 'lastEditedUserName',
                    sortable: true,
                    label: this.$t('Incident.IncLastEditBy'),
                    class: 'text-rigth'
                },
                {
                    key: 'lastEditDateTime',
                    sortable: true,
                    label: this.$t('Incident.IncLastEditDate'),
                    class: 'text-rigth'
                },
                {
                    key: 'incidentID',
                    sortable: true,
                    label: this.$t('Incident.IncId'),
                    class: 'text-rigth'
                }
            ],
            FieldsDateArr: ['incidentDate', 'reportedDate', 'lastEditDateTime'],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            selected: [],
            Header: {},
            refTable: 'selectableTable',
            ShowMessageIsEmpty: true,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            isDateFromValid: true,
            isDateToValid: true
        };
    },
    methods: {
        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0];
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px';
        },

        onHiddenReport() {
            this.isReportVisible = false;
        },

        reportList() {
            this.checkExistFavorite('/app/reports/patients');
            this.$router.push({ name: 'reportListPatient' }).catch(() => {});
        },

        onClickShowReport() {
            this.reportParams = [];
            this.initializePdfParameters();
            this.isReportVisible = true;
            this.$refs.ICRMultipleRep.buildDocument(this.reportParams);
        },

        async CanSeeIncidentAdmin() {
            await IncidentReport.CanSeeIncidentAdmin()
                .then(response => {
                    if (response.data) {
                        this.SeeIncidentAdmin = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getIncidentSetup() {
            IncidentSetup.getAll(this.parameter)
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.IncidentOptions = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getIncidentReportReporter() {
            EmployeeService.getEmployeeLookup()
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.ReporterOptions = response.data.map(element => ({
                            code: element.code,
                            name: element.description
                        }));
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getIncidentReportSeverity() {
            IncidentReportSeveritySetupService.getSeverityAll()
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.SeverityOptions = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getIncidentReportRooms() {
            RoomService.getAllRooms()
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.RoomsOptions = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getPatients() {
            PatientService.getAll(this.fullParam)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.PatientsOptions = response.data;
                        this.PatientsOptions.forEach(function(element) {
                            element.patientname =
                                element.firstname +
                                ' ' +
                                element.lastname +
                                ' - ' +
                                element.patientcode;
                        });
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        ChangeIncident(item) {
            if (item != null) {
                this.CategoryModel = item;

                this.paramCategory = [];
                let selectedCategory = [];
                item.forEach(function(item) {
                    selectedCategory.push(item.code);
                });
                this.paramCategory = selectedCategory;
            } else {
                this.CategoryModel = null;
            }
        },

        ChangeReporter(item) {
            if (item != null) {
                this.ReporterModel = item;

                this.paramReporter = [];
                let selectedReporter = [];
                item.forEach(function(item) {
                    selectedReporter.push(item.code);
                });
                this.paramReporter = selectedReporter;
            } else {
                this.ReporterModel = null;
            }
        },

        ChangeSeverity(item) {
            if (item != null) {
                this.SeverityModel = item;

                this.paramSeverity = [];
                let selectedSeverity = [];
                item.forEach(function(item) {
                    selectedSeverity.push(item.code);
                });
                this.paramSeverity = selectedSeverity;
            } else {
                this.SeverityModel = null;
            }
        },

        ChangeRoom(item) {
            if (item != null) {
                this.RoomModel = item;

                this.paramRoom = [];
                let selectedRoom = [];
                item.forEach(function(item) {
                    selectedRoom.push(item.code);
                });
                this.paramRoom = selectedRoom;
            } else {
                this.RoomModel = null;
            }
        },

        ChangeStatus(item) {
            if (item != null) {
                this.StatusModel = item;

                this.paramStatus = [];
                let selectedStatus = [];
                item.forEach(function(item) {
                    selectedStatus.push(item.value);
                });
                this.paramStatus = selectedStatus;
            } else {
                this.StatusModel = null;
            }
        },

        ChangePatients(item) {
            if (item != null) {
                this.PatientModel = item;

                this.paramPatients = [];
                let selectedPatients = [];
                item.forEach(function(item) {
                    selectedPatients.push(item.patientcode);
                });
                this.paramPatients = selectedPatients;
            } else {
                this.PatientModel = null;
            }
        },

        RemoveItem() {
            let selected = this.StatusOptions.find(el => el.value === 'all');
            if (selected) this.StatusOptions.splice(this.StatusOptions.indexOf(selected), 1);
        },

        getIncidentsReportList() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.initializeParameters();
            IncidentReport.getAll(this.parameter, true)
                .then(response => {
                    if (response.data) {
                        this.items = response.data;
                        this.totalRows = response.data.length > 0 ? response.data[0].maxRows : 0;
                        this.ShowMessageIsEmpty = response.data.length > 0 ? false : true;
                        this.items.forEach(function(element) {
                            if (element.reportedDate)
                                element.reportedDate = Utils.formatterDateTimeToString(
                                    element.reportedDate
                                );
                            if (element.lastEditDateTime)
                                element.lastEditDateTime = Utils.formatterDateTimeToString(
                                    element.lastEditDateTime
                                );
                            if (element.incidentDate)
                                element.incidentDate = `${Utils.formatterDateToString(
                                    element.incidentDate
                                )} ${Utils.formatTime2(element.incidentTime)}`;
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        initializePdfParameters() {
            this.reportParams = [];
            this.reportParams.push({ paramName: 'DateFrom', paramValue: this.dateFrom });
            this.reportParams.push({ paramName: 'DateTo', paramValue: this.dateTo });
            this.reportParams.push({ paramName: 'CategoryCode', paramValue: this.paramCategory });
            this.reportParams.push({ paramName: 'ReporterCode', paramValue: this.paramReporter });
            this.reportParams.push({ paramName: 'SeverityCode', paramValue: this.paramSeverity });
            this.reportParams.push({ paramName: 'RoomCode', paramValue: this.paramRoom });
            this.reportParams.push({ paramName: 'StatusCode', paramValue: this.paramStatus });
            this.reportParams.push({ paramName: 'PatientCode', paramValue: this.paramPatients });
            this.reportParams.push({ paramName: 'IncidentID', paramValue: '' });
            this.reportParams.push({
                paramName: 'searchcriteria',
                paramValue: this.parameter.SearchCriteria
            });
        },

        initializeParameters() {
            this.parameter.PrimaryCategoryCodeList =
                this.paramCategory && this.paramCategory !== '' ? this.paramCategory : null;
            this.parameter.ReporterCodeList =
                this.paramReporter && this.paramReporter !== '' ? this.paramReporter : null;
            this.parameter.SeverityCodeList =
                this.paramSeverity && this.paramSeverity !== '' ? this.paramSeverity : null;
            this.parameter.RoomCodeList =
                this.paramRoom && this.paramRoom !== '' ? this.paramRoom : null;
            this.parameter.PatientCodeList =
                this.paramPatients && this.paramPatients !== '' ? this.paramPatients : null;
            this.parameter.StatusList =
                this.paramStatus && this.paramStatus !== '' ? this.paramStatus : null;
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
        },

        SearchIncidents() {
            if (!this.validateForm()) return;

            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getIncidentsReportList();
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getIncidentsReportList();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getIncidentsReportList();
        },

        handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            try {
                switch (action) {
                    case 'export':
                        this.$refs.csvExportHelper.exportCSV(this.parameter);
                        break;
                    case 'email':
                        this.$refs.csvExportHelper.emailCSV(this.parameter);
                        break;
                    default:
                        console.warn('unknow action:', action);
                        break;
                }
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            try {
                switch (action) {
                    case 'export':
                        this.$refs.csvExportHelper.exportToPdf(
                            'ICRMultipleReport',
                            true,
                            false,
                            this.reportParams
                        );
                        break;
                    case 'email':
                        this.$refs.csvExportHelper.emailPdf(
                            'ICRMultipleReport',
                            true,
                            false,
                            this.reportParams
                        );
                        break;
                    default:
                        console.warn('unknow action:', action);
                        break;
                }
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
        },

        // Método de validación reutilizable
        validateForm() {
            const isValid = this.validate_date_range();

            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;

            // Forzar actualización del componente
            this.$forceUpdate();

            if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), 'error');
                return false;
            }
            return true;
        }
    },

    async created() {
        await this.CanSeeIncidentAdmin();
    },

    mounted() {
        this.getIncidentSetup();
        this.getIncidentReportRooms();
        this.getIncidentReportReporter();
        this.getIncidentReportSeverity();
        this.getPatients();
        this.RemoveItem();
        EventBus.$on(
            'ShowWeel',
            function(isShow) {
                isShow ? this.$emit('load', true) : this.$emit('load', false);
            }.bind(this)
        );
    }
});
</script>
<style>
.dxrd-report-preview-holder {
    height: 94% !important;
}
</style>
